import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import { useTheme } from '@mui/material/styles';
import { getColors } from '@mercedes-benz/odp-theme-v2';

type SnackbarProps = {
  open: boolean;
  message: string;
  onClose: () => void;
  autoHideDuration?: number;
};

export const CustomSnackbar = ({
  open,
  message,
  onClose,
  autoHideDuration = 6000,
}: SnackbarProps) => {
  const theme = useTheme();
  const colours = getColors(theme.palette.mode);

  const action = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={onClose}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
    >
      <SnackbarContent
        action={action}
        sx={{
          backgroundColor: colours.primary.main,
          color: 'white',
        }}
        message={
          <Box
            sx={{
              width: '532px',
              fontSize: '14px',
              paddingLeft: '22px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <InfoIcon sx={{ marginRight: '16px' }} />
            <span>{message}</span>
          </Box>
        }
      />
    </Snackbar>
  );
};
